import React, { ReactElement } from 'react';
import { Helmet } from 'react-helmet-async';

interface IAppVersionScriptProps {
  version: string;
  environment: string;
}

export const AppVersionScript = ({
  version,
  environment,
}: IAppVersionScriptProps): ReactElement => {
  const monitoringScript = `
  window.$appVersions = window.$appVersions || {};
  window.$appVersions.corpManagementUI = {
    version: '${version}',
    environment: '${environment}',
  }
  console.log(JSON.stringify(window.$appVersions));
  `;

  return (
    <Helmet defer={false}>
      <script type="text/javascript">{monitoringScript}</script>
    </Helmet>
  );
};
